import { components } from '@plandi/common/src/generated'
import { useLocale } from '@plandi/common'

export const Translations = () => {
  const locale = useLocale()

  const FEATURES: Record<string, string> = {
    'ready-to-work-for-company':
      locale === 'ru'
        ? 'Готов работать на компанию'
        : 'Ready to work for the company',
    'possibility-of-departure-on-object':
      locale === 'ru'
        ? 'Возможность выезда на объект'
        : 'Possibility of visiting the site',
    'business-trips-possible':
      locale === 'ru' ? 'Возможны командировки' : 'Business trips possible',
    'existence-car': locale === 'ru' ? 'Наличие авто' : 'Existence of a car'
  }

  const EMPLOYMENT_TYPE: Record<
    components['schemas']['EmploymentType'],
    string
  > = {
    'full-time': locale === 'ru' ? 'Полная занятость' : 'Full-time',
    'part-time': locale === 'ru' ? 'Частичная занятость' : 'Part-time',
    project: locale === 'ru' ? 'Проектная/временная работа' : 'Project work',
    internship: locale === 'ru' ? 'Стажировка' : 'Internship'
  }

  const FREELANCE_TYPE: Record<string, string> = {
    free: locale === 'ru' ? 'Свободен для работы' : 'Available for work',
    'low-busy': locale === 'ru' ? 'Немного занят' : 'Slightly busy',
    'high-busy': locale === 'ru' ? 'Сильно занят' : 'Very busy',
    'temporarily-down':
      locale === 'ru' ? 'Временно не работаю' : 'Temporarily not working',
    vacation: locale === 'ru' ? 'В отпуске' : 'On vacation'
  }

  const SCHEDULE_TYPE: Record<components['schemas']['Schedule'], string> = {
    'remote-work': locale === 'ru' ? 'Удаленная работа' : 'Remote work',
    'part-time': locale === 'ru' ? 'Частичная занятость' : 'Part-time',
    'full-day': locale === 'ru' ? 'Полный день' : 'Full day',
    'shift-work': locale === 'ru' ? 'Сменный график' : 'Shift work',
    flexible: locale === 'ru' ? 'Гибкий график' : 'Flexible schedule',
    internship: locale === 'ru' ? 'Стажировка' : 'Internship'
  }

  const EDUCATION_TYPE: Record<components['schemas']['EducationType'], string> =
    {
      higher: locale === 'ru' ? 'Высшее' : 'Higher',
      'incomplete-higher':
        locale === 'ru' ? 'Незаконченное высшее' : 'Incomplete Higher',
      secondary: locale === 'ru' ? 'Среднее' : 'Secondary',
      'specialized-secondary':
        locale === 'ru' ? 'Среднее специальное' : 'Specialized Secondary'
    }

  const GENDER_TYPE: Record<string, string> = {
    male: locale === 'ru' ? 'Мужской' : 'Male',
    female: locale === 'ru' ? 'Женский' : 'Female'
  }

  const EXPERIENCES: Record<string, string> = {
    without: locale === 'ru' ? 'Без опыта' : 'Without experience',
    '1-3': locale === 'ru' ? '1-3 года' : '1-3 years',
    '3-5': locale === 'ru' ? '3-5 лет' : '3-5 years',
    'more-6': locale === 'ru' ? 'Больше 6 лет' : 'More than 6 years'
  }

  return {
    FEATURES,
    EMPLOYMENT_TYPE,
    FREELANCE_TYPE,
    SCHEDULE_TYPE,
    EDUCATION_TYPE,
    GENDER_TYPE,
    EXPERIENCES
  }
}
